import React from 'react';
import { useModal } from 'react-modal-hook';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button, Icon, Text } from 'components';
import { EmployeeOnboardingModal } from 'components/EmployeeOnboarding/EmployeeOnboardingModal';
import { theme, toRem } from 'design';
import { selectCurrentEmployeeSite } from 'store/Employers';
import { PermissionType } from 'types';
import { hasSitePermission } from 'utils';
import { Title } from '../../../styles';

const Layout = styled.div`
  flex-direction: column;
  align-items: flex-start;
  padding: ${toRem(theme.space.xl)};
  gap: ${toRem(theme.space.lg)};
  background: ${theme.color.primary[25]};
  border: ${toRem(1)} solid ${theme.color.primary[500]};
  border-radius: ${toRem(8)};
  align-self: stretch;
  flex-grow: 0;
  margin-top: ${toRem(theme.space.lg)};

  p {
    color: ${theme.color.neutral[600]};
  }
`;

const StyledButton = styled(Button)`
  width: ${toRem(200)} !important;
`;

const StyledIcon = styled(Icon)`
  position: relative;
  margin-right: ${toRem(theme.space.sm)};
  fill: ${theme.color.primary[600]};
  top: ${toRem(3)};
`;

interface IEmployeeOnboardingProps {
  dataCy?: string;
}
export const EmployeeOnboarding: React.FC<IEmployeeOnboardingProps> = ({ dataCy = 'employee-onboarding' }) => {
  const currentEmployerSite = useSelector(selectCurrentEmployeeSite);
  const permission = hasSitePermission(currentEmployerSite?.permissions, PermissionType.EMPLOYEE_ONBOARDING_VIEW);
  const [showEmployeeOnboardingModal, hideEmployeeOnboardingModal] = useModal(() => <EmployeeOnboardingModal siteId={currentEmployerSite.id} onClose={hideEmployeeOnboardingModal} />, [currentEmployerSite]);

  // Do not display if user does not have permission
  if (!permission) return <></>;

  return (
    <Layout data-cy={dataCy}>
      <Title fontWeight="medium">
        <StyledIcon icon="People" />
        Employee Onboarding
      </Title>
      <Text size="xsmall">Onboard employees from the connected POS system.</Text>
      <StyledButton appearance="primary" size="small" label="Start Employee Onboarding" data-cy={`${dataCy}-button`} onClick={showEmployeeOnboardingModal} />
    </Layout>
  );
};
